import { useContext } from 'react'
import { FlexGrid } from '@telus-uds/components-web'
import Heading from '@/siteBuilder/blocks/core/Heading/Heading'
import { HeadingContainer } from '../styles'
import FilterTags from '../../FilterTags'
import MultiSelectFilter from '../../MultiSelectFilter'
import useBBViewport from '@/hooks/useBBViewport'
import { filterTags } from '@/blogBuilder/utils/types/theme'
import { articleConsumer } from '../../../provider/ArticleProvider'

type Props = {
  filterTags: { tags: filterTags; category: string }[] | []
  lang: string
}

const HeadingPreview = ({ filterTags, lang }: Props) => {
  const { selectedCategory } = useContext(articleConsumer)
  const tags = filterTags.length
    ? filterTags.find((d: { tags: filterTags; category: string }) => {
        if (lang === 'fr' && d?.category?.toLowerCase() === 'all') return 'tout' === selectedCategory?.toLowerCase()
        return d?.category?.toLowerCase() === selectedCategory?.toLowerCase()
      })?.tags
    : []

  const viewport = useBBViewport()

  const isMobile = viewport === `xs` || viewport === 'sm' ? true : false

  const filterTitle = lang === 'fr' ? 'Filtres' : 'Filters'
  return (
    <FlexGrid.Col xs={12}>
      {filterTags?.length > 0 && !isMobile && (
        <HeadingContainer>
          <Heading heading="h3" size="h2" text={filterTitle} />
        </HeadingContainer>
      )}
      <div style={{ marginBottom: '1.5rem' }}>
        {!isMobile ? (
          <FilterTags tags={[...new Set(tags)]} lang={lang} />
        ) : (
          <MultiSelectFilter label={filterTitle} items={[...new Set(tags)]} lang={lang} />
        )}
      </div>
    </FlexGrid.Col>
  )
}

export default HeadingPreview
